import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Box, Button, Grid, makeStyles, TextField } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import LockIcon from '@material-ui/icons/Lock';
import * as Yup from 'yup';

import styles from './styles';
import { Field, Form, Formik } from 'formik';
import notification from 'app/config/notification';
const useStyles = makeStyles(styles);

function LoginForm({ intl, onSubmit, onRegister, onRecovery, onChangeEmail }) {
    const classes = useStyles();

    const validationSchema = Yup.object().shape({
        username: Yup.string().required('O CPF/CNPJ é obrigatório'),
        password: Yup.string().required('A senha é obrigatória'),
    });

    const validateFormLogin = (functionValidation) => {
        functionValidation.then((res) => {
            if (Object.keys(res).length > 0) {
                notification(intl.formatMessage({ id: 'MESSAGES.LOGIN.MISSING_MANDATORY_INFO_LOGIN' }), {
                    toastId: 'VALIDATION',
                    type: 'error',
                });
            }
        });
    };

    return (
        <Formik
            initialValues={{ username: '', password: '' }}
            validationSchema={validationSchema}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={(values) => {
                onSubmit(values);
            }}>
            {({ errors, validateForm }) => {
                return (
                    <Form>
                        <Box maxWidth={400} padding={4}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} className={classes.boxTextField}>
                                    <PersonIcon className={classes.icone} color="disabled" />
                                    <Field
                                        name="username"
                                        label="CPF / CNPJ"
                                        variant="filled"
                                        fullWidth
                                        error={!!errors.username}
                                        as={TextField}
                                    />
                                </Grid>
                                <Box className={classes.box}>
                                    <span className={classes.textBlue}>
                                        <FormattedMessage id="LABELS.LOGIN.INFO_USERNAME" />
                                    </span>
                                </Box>
                                <Grid item xs={12} className={classes.boxTextField}>
                                    <LockIcon className={classes.icone} color="disabled" />
                                    <Field
                                        name="password"
                                        label="Senha"
                                        type="password"
                                        variant="filled"
                                        fullWidth
                                        error={!!errors.password}
                                        as={TextField}
                                    />
                                </Grid>
                                <Box className={classes.box}>
                                    <Button
                                        size="small"
                                        className={[classes.register, classes.textBlue].join(' ')}
                                        onClick={onRegister}>
                                        <FormattedMessage id="LABELS.COMMONS.REGISTER" />
                                    </Button>
                                    <Button
                                        size="small"
                                        className={[classes.forgotPassword, classes.textBlue].join(' ')}
                                        onClick={onRecovery}>
                                        <FormattedMessage id="LABELS.COMMONS.FORGOT_MY_PASSWORD" />
                                    </Button>
                                </Box>
                                <Grid item xs={12} className={[classes.item, classes.smallItem].join(' ')}>
                                    <div className={classes.item}>
                                        <Button
                                            size="small"
                                            className={[classes.register, classes.textBlue].join(' ')}
                                            onClick={onChangeEmail}>
                                            <FormattedMessage id="LABELS.COMMONS.CHANGE_EMAIL" />
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid item xs={12} className={classes.item}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        className={classes.loginButton}
                                        onClick={() => {
                                            validateForm && validateFormLogin(validateForm());
                                        }}>
                                        <FormattedMessage id="LABELS.COMMONS.ENTER" />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default injectIntl(LoginForm);
